export const WORK_ORDER_GET_STARTED = 'WORK_ORDER_GET_STARTED';
export const WORK_ORDER_GET_FINISHED = 'WORK_ORDER_GET_FINISHED';
export const WORK_ORDER_GET_FAILED = 'WORK_ORDER_GET_FAILED';
export const WORK_ORDER_GET_TECH_ROUTE_STARTED = 'WORK_ORDER_GET_TECH_ROUTE_STARTED';
export const WORK_ORDER_GET_TECH_ROUTE_FINISHED = 'WORK_ORDER_GET_TECH_ROUTE_FINISHED';
export const WORK_ORDER_GET_TECH_ROUTE_FAILED = 'WORK_ORDER_GET_TECH_ROUTE_FAILED';
export const TRANSACTION_LOG_SEND_STARTED = 'TRANSACTION_LOG_SEND_STARTED';
export const TRANSACTION_LOG_SEND_FINISHED = 'TRANSACTION_LOG_SEND_FINISHED';
export const TRANSACTION_LOG_SEND_FAILED = 'TRANSACTION_LOG_SEND_FAILED';
export const REMOVE_ERROR = 'REMOVE_ERROR';
export const ADD_TRANSACTION_LOG = 'ADD_TRANSACTION_LOG';
export const SET_VEHICLE_NUMBER = 'SET_VEHICLE_NUMBER';
export const SAVE_VEHICLE_NUMBER = 'SAVE_VEHICLE_NUMBER';
export const RESET_VEHICLE_SAVED = 'RESET_VEHICLE_SAVED';
export const GET_TECH_STATUS_STARTED = 'GET_TECH_STATUS_STARTED';
export const GET_TECH_STATUS_FINISHED = 'GET_TECH_STATUS_FINISHED';
export const GET_TECH_STATUS_FAILED = 'GET_TECH_STATUS_FAILED';
export const SET_TECH_STATUS_READY = 'SET_TECH_STATUS_READY';
export const SET_TECH_STATUS_IN_ROUTE = 'SET_TECH_STATUS_IN_ROUTE';
export const SET_TECH_STATUS_ON_BREAK = 'SET_TECH_STATUS_ON_BREAK';
export const SET_TECH_STATUS_OFF_BREAK = 'SET_TECH_STATUS_OFF_BREAK';
export const SET_TECH_STATUS_UNDO_ON_JOB = 'SET_TECH_STATUS_UNDO_ON_JOB';
export const SET_TECH_STATUS_UNDO_IN_ROUTE = 'SET_TECH_STATUS_UNDO_IN_ROUTE';
export const SET_TECH_STATUS_NOT_READY = 'SET_TECH_STATUS_NOT_READY';
export const SET_TECH_STATUS_ON_JOB = 'SET_TECH_STATUS_ON_JOB';
export const SET_TECH_STATUS_WAITING = 'SET_TECH_STATUS_WAITING';
export const SET_TECH_STATUS_FINISHED = 'SET_TECH_STATUS_FINISHED';
export const SET_TECH_STATUS_FAILED = 'SET_TECH_STATUS_FAILED';
export const SET_TECH_SEARCH_PROPERTY = 'SET_TECH_SEARCH_PROPERTY';
export const SET_TECH_TRANSFER_TO_PROPERTY = 'SET_TECH_TRANSFER_TO_PROPERTY';
export const GET_TECH_INFO_STARTED = 'GET_TECH_INFO_STARTED';
export const GET_TECH_INFO_FINISHED = 'GET_TECH_INFO_FINISHED';
export const GET_TECH_INFO_FAILED = 'GET_TECH_INFO_FAILED';
export const SET_TECH_SEARCH_TOP_MATCH = 'SET_TECH_SEARCH_TOP_MATCH';
export const SET_ARRIVAL_TIME = 'SET_ARRIVAL_TIME';
export const SET_PUBNUB_TOKEN = 'SET_PUBNUB_TOKEN';
export const SHOW_ARRIVAL_TIME_DIALOG = 'SHOW_ARRIVAL_TIME_DIALOG';
export const HIDE_ARRIVAL_TIME_DIALOG = 'HIDE_ARRIVAL_TIME_DIALOG';
export const USER_LOGIN_FAILED = 'USER_LOGIN_FAILED';
export const SET_EDITING_STATUS = 'SET_EDITING_STATUS';
export const SET_SCANNER_ERROR = 'SET_SCANNER_ERROR';
export const SET_SCANNER_RESULTS = 'SET_SCANNER_RESULTS';
export const USER_INFO_LOAD_STARTED = 'USER_INFO_LOAD_STARTED';
export const USER_INFO_LOAD_FINISHED = 'USER_INFO_LOAD_FINISHED';
export const USER_INFO_LOAD_FAILED = 'USER_INFO_LOAD_FAILED';
export const TOGGLE_DRAWER = 'TOGGLE_DRAWER';
export const WORK_ORDER_DETAIL_PAGE_OPENED = 'WORK_ORDER_DETAIL_PAGE_OPENED';
export const CLEAR_WORK_ORDER_DETAIL = 'CLEAR_WORK_ORDER_DETAIL';
export const SET_THEME = 'SET_THEME';
export const SET_USER_ID = 'SET_USER_ID';
export const ADD_MEMO_STARTED = 'ADD_MEMO_STARTED';
export const ADD_MEMO_FINISHED = 'ADD_MEMO_FINISHED';
export const ADD_MEMO_FAILED = 'ADD_MEMO_FAILED';
export const SET_NEW_MEMO = 'SET_NEW_MEMO';
export const MAKE_ACCOUNT_NUMBER_POSITIVE = 'MAKE_ACCOUNT_NUMBER_POSITIVE';
export const CHECK_FOR_EXPIRED_ITEMS = 'CHECK_FOR_EXPIRED_ITEMS';
export const SET_WORK_ORDER_SECTION_COLLAPSED = 'SET_WORK_ORDER_SECTION_COLLAPSED';
export const SQC_GENERATE_STARTED = 'SQC_GENERATE_STARTED';
export const SQC_GENERATE_FINISHED = 'SQC_GENERATE_FINISHED';
export const SQC_GENERATE_FAILED = 'SQC_GENERATE_FAILED';
export const SQC_DIALOG_TOGGLE = 'SQC_DIALOG_TOGGLE';
export const SET_ORDER_DETAIL_TYPE = 'SET_ORDER_DETAIL_TYPE';
export const SET_SLIDE_INDEX = 'SET_SLIDE_INDEX';
export const TECH_INVENTORY_GET_STARTED = 'TECH_INVENTORY_GET_STARTED';
export const TECH_INVENTORY_GET_FINISHED = 'TECH_INVENTORY_GET_FINISHED';
export const TECH_INVENTORY_GET_FAILED = 'TECH_INVENTORY_GET_FAILED';
export const INVENTORY_SEARCH_STARTED = 'INVENTORY_SEARCH_STARTED';
export const INVENTORY_SEARCH_FINISHED = 'INVENTORY_SEARCH_FINISHED';
export const INVENTORY_SEARCH_FAILED = 'INVENTORY_SEARCH_FAILED';
export const INVENTORY_TRANSFER_STARTED = 'INVENTORY_TRANSFER_STARTED';
export const INVENTORY_TRANSFER_FINISHED = 'INVENTORY_TRANSFER_FINISHED';
export const INVENTORY_TRANSFER_FAILED = 'INVENTORY_TRANSFER_FAILED';
export const SET_INVENTORY_SEARCH_VALUE = 'SET_INVENTORY_SEARCH_VALUE';
export const CHARGE_ADD_STARTED = 'CHARGE_ADD_STARTED';
export const CHARGE_ADD_FINISHED = 'CHARGE_ADD_FINISHED';
export const CHARGE_ADD_FAILED = 'CHARGE_ADD_FAILED';
export const CHARGE_UPDATE_STARTED = 'CHARGE_UPDATE_STARTED';
export const CHARGE_UPDATE_FINISHED = 'CHARGE_UPDATE_FINISHED';
export const CHARGE_UPDATE_FAILED = 'CHARGE_UPDATE_FAILED';
export const CHARGE_UPDATE_CANCELLED = 'CHARGE_UPDATE_CANCELLED';
export const CHARGE_REMOVE_STARTED = 'CHARGE_REMOVE_STARTED';
export const CHARGE_REMOVE_FINISHED = 'CHARGE_REMOVE_FINISHED';
export const CHARGE_REMOVE_FAILED = 'CHARGE_REMOVE_FAILED';
export const CHARGE_QUANTITY_SET = 'CHARGE_QUANTITY_SET';
export const JUST_ASK_QUANTITY_SET = 'JUST_ASK_QUANTITY_SET';
export const JUST_ASK_ADD_STARTED = 'JUST_ASK_ADD_STARTED';
export const JUST_ASK_ADD_FINISHED = 'JUST_ASK_ADD_FINISHED';
export const JUST_ASK_ADD_FAILED = 'JUST_ASK_ADD_FAILED';
export const JUST_ASK_UPDATE_STARTED = 'JUST_ASK_UPDATE_STARTED';
export const JUST_ASK_UPDATE_FINISHED = 'JUST_ASK_UPDATE_FINISHED';
export const JUST_ASK_UPDATE_FAILED = 'JUST_ASK_UPDATE_FAILED';
export const WORK_ORDER_BY_ORDER_ID_GET_STARTED = 'WORK_ORDER_BY_ORDER_ID_GET_STARTED';
export const WORK_ORDER_BY_ORDER_ID_GET_FINISHED = 'WORK_ORDER_BY_ORDER_ID_GET_FINISHED';
export const WORK_ORDER_BY_ORDER_ID_GET_FAILED = 'WORK_ORDER_BY_ORDER_ID_GET_FAILED';
export const SET_CLOSE_STEP = 'SET_CLOSE_STEP';
export const CLOSE_CODE_GET_STARTED = 'CLOSE_CODE_GET_STARTED';
export const CLOSE_CODE_GET_FINISHED = 'CLOSE_CODE_GET_FINISHED';
export const CLOSE_CODE_GET_FAILED = 'CLOSE_CODE_GET_FAILED';
export const CLOSE_CODE_ADD = "CLOSE_CODE_ADD";
export const CLOSE_CODE_REMOVE = "CLOSE_CODE_REMOVE";
export const CLOSE_COMMENT_SET = "CLOSE_COMMENT_SET";
export const DROP_BURY_SET = "DROP_BURY_SET";
export const TICKET_REQUEST_ADD = "TICKET_REQUEST_ADD";
export const TICKET_REQUEST_REMOVE = "TICKET_REQUEST_REMOVE";
export const CLOSE_ORDER_STATUS_SET = "CLOSE_ORDER_STATUS_SET";
export const OUTLET_OPTIMIZATION_STATUS_SET = "OUTLET_OPTIMIZATION_STATUS_SET";
export const CHARGE_COMMENT_SET = 'CHARGE_COMMENT_SET';
export const SET_CURRENT_TECH_ID = 'SET_CURRENT_TECH_ID';
export const USER_CHANNEL_GRANT_STARTED = "USER_CHANNEL_GRANT_STARTED";
export const USER_CHANNEL_GRANT_FINISHED = 'USER_CHANNEL_GRANT_FINISHED';
export const USER_CHANNEL_GRANT_FAILED = 'USER_CHANNEL_GRANT_FAILED';
export const USER_CHANNEL_GRANT_APPIAN_STARTED = "USER_CHANNEL_GRANT_APPIAN_STARTED";
export const USER_CHANNEL_GRANT_APPIAN_FINISHED = "USER_CHANNEL_GRANT_APPIAN_FINISHED";
export const USER_CHANNEL_GRANT_APPIAN_FAILED = "USER_CHANNEL_GRANT_APPIAN_FAILED";
export const OUTLET_UPDATE = 'OUTLET_UPDATE';
export const OUTLET_UPDATE_APPIAN_STARTED = 'OUTLET_UPDATE_APPIAN_STARTED';
export const OUTLET_UPDATE_APPIAN_FINISHED = 'OUTLET_UPDATE_APPIAN_FINISHED';
export const OUTLET_UPDATE_APPIAN_FAILED = 'OUTLET_UPDATE_APPIAN_FAILED';
export const OUTLET_UPDATE_STARTED = 'OUTLET_UPDATE_STARTED';
export const OUTLET_UPDATE_FINISHED = 'OUTLET_UPDATE_FINISHED';
export const OUTLET_UPDATE_FAILED = 'OUTLET_UPDATE_FAILED';
export const OUTLET_UPDATE_EQUIPMENT_REFRESHED = 'OUTLET_UPDATE_EQUIPMENT_REFRESHED';
export const ORDER_CLOSE_STARTED = 'ORDER_CLOSE_STARTED';
export const ORDER_CLOSE_WAITING = 'ORDER_CLOSE_WAITING';
export const ORDER_CLOSE_FINISHED = 'ORDER_CLOSE_FINISHED';
export const ORDER_CLOSE_FAILED = 'ORDER_CLOSE_FAILED';
export const ORDER_CLOSE_REQUEST_ADD_STARTED = 'ORDER_CLOSE_REQUEST_ADD_STARTED';
export const ORDER_CLOSE_REQUEST_ADD_FINISHED = 'ORDER_CLOSE_REQUEST_ADD_FINISHED';
export const ORDER_CLOSE_REQUEST_ADD_FAILED = 'ORDER_CLOSE_REQUEST_ADD_FAILED';
export const SET_SHOW_ORDER_CLOSED = 'SET_SHOW_ORDER_CLOSED';
export const ORDER_HISTORY_REQUEST_STARTED = 'ORDER_HISTORY_REQUEST_STARTED';
export const ORDER_HISTORY_REQUEST_FINISHED = 'ORDER_HISTORY_REQUEST_FINISHED';
export const ORDER_HISTORY_REQUEST_FAILED = 'ORDER_HISTORY_REQUEST_FAILED';
export const TECH_HISTORY_REQUEST_STARTED = 'TECH_HISTORY_REQUEST_STARTED';
export const TECH_HISTORY_REQUEST_FINISHED = 'TECH_HISTORY_REQUEST_FINISHED';
export const TECH_HISTORY_REQUEST_FAILED = 'TECH_HISTORY_REQUEST_FAILED';
export const SET_TECH_HISTORY_TECH_ID = 'SET_TECH_HISTORY_TECH_ID';
export const SET_TECH_HISTORY_START_DATE = 'SET_TECH_HISTORY_START_DATE';
export const SET_TECH_HISTORY_END_DATE = 'SET_TECH_HISTORY_END_DATE';
export const EQUIPMENT_HIT_STARTED = 'EQUIPMENT_HIT_STARTED';
export const EQUIPMENT_HIT_FINISHED = 'EQUIPMENT_HIT_FINISHED';
export const EQUIPMENT_HIT_FAILED = 'EQUIPMENT_HIT_FAILED';
export const EQUIPMENT_BALANCING_HIT_STARTED = 'EQUIPMENT_BALANCING_HIT_STARTED';
export const EQUIPMENT_BALANCING_HIT_FINISHED = 'EQUIPMENT_BALANCING_HIT_FINISHED';
export const EQUIPMENT_BALANCING_HIT_FAILED = 'EQUIPMENT_BALANCING_HIT_FAILED';
export const EQUIPMENT_REFRESH_HIT_STARTED = 'EQUIPMENT_REFRESH_HIT_STARTED';
export const EQUIPMENT_REFRESH_HIT_FINISHED = 'EQUIPMENT_REFRESH_HIT_FINISHED';
export const EQUIPMENT_REFRESH_HIT_FAILED = 'EQUIPMENT_REFRESH_HIT_FAILED';
export const TAG_UPDATE_STARTED = 'TAG_UPDATE_STARTED';
export const TAG_UPDATE_FINISHED = 'TAG_UPDATE_FINISHED';
export const TAG_UPDATE_FAILED = 'TAG_UPDATE_FAILED';
export const SET_TAG_NUMBERS = 'SET_TAG_NUMBERS';
export const SET_TAG_EDITING = 'SET_TAG_EDITING';
export const SET_OUTLET_EXPANDED = 'SET_OUTLET_EXPANDED';
export const PUBLISH_MESSAGE = 'PUBLISH_MESSAGE';
export const SET_PRESENCE_DATA = 'SET_PRESENCE_DATA';
export const SET_CHANNEL_DATA = 'SET_CHANNEL_DATA';
export const SET_APPIAN_CHANNEL_DATA = 'SET_APPIAN_CHANNEL_DATA';
export const EQUIPMENT_OPTION_QTY_SET = 'EQUIPMENT_OPTION_QTY_SET';
export const EQUIPMENT_OPTION_CLEAR = 'EQUIPMENT_OPTION_CLEAR';
export const EQUIPMENT_OPTION_SUBMIT_STARTED = 'EQUIPMENT_OPTION_SUBMIT_STARTED';
export const EQUIPMENT_OPTION_SUBMIT_FINISHED = 'EQUIPMENT_OPTION_SUBMIT_FINISHED';
export const EQUIPMENT_OPTION_SUBMIT_FAILED = 'EQUIPMENT_OPTION_SUBMIT_FAILED';
export const UNPAIR_PAIR_STARTED = 'UNPAIR_PAIR_STARTED';
export const UNPAIR_PAIR_FINISHED = 'UNPAIR_PAIR_FINISHED';
export const UNPAIR_PAIR_FAILED = 'UNPAIR_PAIR_FAILED';
export const SIGNATURE_CAPTURE_UPDATE = 'SIGNATURE_CAPTURE_UPDATE';
export const SET_NEW_CUSTOMER_EMAIL = 'SET_NEW_CUSTOMER_EMAIL';
export const SET_NEW_CUSTOMER_EMAIL_EDIT_MODE = 'SET_NEW_CUSTOMER_EMAIL_EDIT_MODE';
export const RESET_CUSTOMER_EMAIL_EDIT = 'RESET_CUSTOMER_EMAIL_EDIT';
export const UPDATE_CUSTOMER_EMAIL_STARTED = 'UPDATE_CUSTOMER_EMAIL_STARTED';
export const UPDATE_CUSTOMER_EMAIL_FINISHED = 'UPDATE_CUSTOMER_EMAIL_FINISHED';
export const UPDATE_CUSTOMER_EMAIL_FAILED = 'UPDATE_CUSTOMER_EMAIL_FAILED';
export const UPDATE_CUSTOMER_EMAIL_MESSAGE_RESET = 'UPDATE_CUSTOMER_EMAIL_MESSAGE_RESET';

export const GET_ADDRESS_FROM_BILLER_STARTED = 'GET_ADDRESS_FROM_BILLER_STARTED';
export const GET_ADDRESS_FROM_BILLER_FINISHED = 'GET_ADDRESS_FROM_BILLER_FINISHED';
export const GET_ADDRESS_FROM_BILLER_FAILED = 'GET_ADDRESS_FROM_BILLER_FAILED';

export const SUBMIT_UNNECESSARY_TRUCK_ROLL_STARTED = 'SUBMIT_UNNECESSARY_TRUCK_ROLL_STARTED';
export const SUBMIT_UNNECESSARY_TRUCK_ROLL_FINISHED = 'SUBMIT_UNNECESSARY_TRUCK_ROLL_FINISHED';
export const SUBMIT_UNNECESSARY_TRUCK_ROLL_FAILED = 'SUBMIT_UNNECESSARY_TRUCK_ROLL_FAILED';

export const SET_TRUCK_ROLL_CLOSE_SUBMITTED = 'SET_TRUCK_ROLL_CLOSE_SUBMITTED';
export const SET_TRUCK_ROLL_CLOSE_UNNECESSARY_VALUE = 'SET_TRUCK_ROLL_CLOSE_UNNECESSARY_VALUE';
export const SET_TRUCK_ROLL_CLOSE_COMMENT = 'SET_TRUCK_ROLL_CLOSE_COMMENT';

export const ACTIVE_SERVICES_REQUEST_STARTED = 'ACTIVE_SERVICES_REQUEST_STARTED';
export const ACTIVE_SERVICES_REQUEST_FINISHED = 'ACTIVE_SERVICES_REQUEST_FINISHED';
export const ACTIVE_SERVICES_REQUEST_FAILED = 'ACTIVE_SERVICES_REQUEST_FAILED';

export const PROVISIONING_STATUS_REQUEST_STARTED = 'PROVISIONING_STATUS_REQUEST_STARTED';
export const PROVISIONING_STATUS_REQUEST_FINISHED = 'PROVISIONING_STATUS_REQUEST_FINISHED';
export const PROVISIONING_STATUS_REQUEST_FAILED = 'PROVISIONING_STATUS_REQUEST_FAILED';

export const PROVISIONING_SET_ACCOUNT_NUMBER = 'PROVISIONING_SET_ACCOUNT_NUMBER';
export const PROVISIONING_CLEAR_ACCOUNT_NUMBER = 'PROVISIONING_CLEAR_ACCOUNT_NUMBER';

export const PROVISIONING_SET_SERVICE_ORDER_NUMBER = 'PROVISIONING_SET_SERVICE_ORDER_NUMBER';
export const PROVISIONING_CLEAR_SERVICE_ORDER_NUMBER = 'PROVISIONING_CLEAR_ACCOUNT_NUMBERSERVICE_ORDER_NUMBER';

export const GET_HOME_VERIFY_STARTED = 'GET_HOME_VERIFY_STARTED';
export const GET_HOME_VERIFY_FINISHED = 'GET_HOME_VERIFY_FINISHED';
export const GET_HOME_VERIFY_FAILED = 'GET_HOME_VERIFY_FAILED';
export const SET_HOME_VERIFY_STARTED = 'SET_HOME_VERIFY_STARTED';
export const SET_HOME_VERIFY_FINISHED = 'SET_HOME_VERIFY_FINISHED';
export const SET_HOME_VERIFY_FAILED = 'SET_HOME_VERIFY_FAILED';

export const SET_HOME_VERIFY_STATE = 'SET_HOME_VERIFY_STATE';
export const SET_HOME_VERIFY_MESSAGE = 'SET_HOME_VERIFY_MESSAGE';

export const SET_ACTIVELY_SELECTED_WORK_ORDER_ID = 'SET_ACTIVELY_SELECTED_WORK_ORDER_ID';

export const PIN_RESET_STARTED = 'PIN_RESET_STARTED';
export const PIN_RESET_FINISHED = 'PIN_RESET_FINISHED';
export const PIN_RESET_FAILED = 'PIN_RESET_FAILED';
export const PIN_RESET_RESET = 'PIN_RESET_RESET';

export const SET_IN_HOME_ACCESS = 'SET_IN_HOME_ACCESS';

export const SET_FST_SIGNAL_VALUE = 'SET_FST_SIGNAL_VALUE';
export const GET_DIGITAL_CHANNELS_STARTED = 'GET_DIGITAL_CHANNELS_STARTED';
export const GET_DIGITAL_CHANNELS_FINISHED = 'GET_DIGITAL_CHANNELS_FINISHED';
export const GET_DIGITAL_CHANNELS_FAILED = 'GET_DIGITAL_CHANNELS_FAILED';
export const SET_TECHID_SIGNAL_LEVELS = 'SET_TECHID_SIGNAL_LEVELS';

export const SET_DELIVERY_PROOF_IMAGE = 'SET_DELIVERY_PROOF_IMAGE';
export const REMOVE_DELIVERY_PROOF_IMAGE = 'REMOVE_DELIVERY_PROOF_IMAGE';
export const SET_DELIVERY_PROOF_DESCRIPTION = 'SET_DELIVERY_PROOF_DESCRIPTION';
export const DELIVERY_PROOF_SUBMIT_STARTED = 'DELIVERY_PROOF_SUBMIT_STARTED';
export const DELIVERY_PROOF_SUBMIT_FINISHED = 'DELIVERY_PROOF_SUBMIT_FINISHED';
export const DELIVERY_PROOF_SUBMIT_FAILED = 'DELIVERY_PROOF_SUBMIT_FAILED';
export const DELIVERY_PROOF_INIT = 'DELIVERY_PROOF_INIT';
export const SET_NOACCESS_REASON = 'SET_NOACCESS_REASON';
export const GET_NOACCESS_REASONS_STARTED = 'GET_NOACCESS_REASONS_STARTED';
export const GET_NOACCESS_REASONS_FINISHED = 'GET_NOACCESS_REASONS_FINISHED';
export const GET_NOACCESS_REASONS_FAILED = 'GET_NOACCESS_REASONS_FAILED';
export const SET_DELIVERY_PROOF_BYPASS_FLAG = 'SET_DELIVERY_PROOF_BYPASS_FLAG';

export const ASURION_PLUS_ENROLLMENT_SUBMIT_STARTED = 'ASURION_PLUS_ENROLLMENT_SUBMIT_STARTED';
export const ASURION_PLUS_ENROLLMENT_SUBMIT_FINISHED = 'ASURION_PLUS_ENROLLMENT_SUBMIT_FINISHED';
export const ASURION_PLUS_ENROLLMENT_SUBMIT_FAILED = 'ASURION_PLUS_ENROLLMENT_SUBMIT_FAILED';
export const EQUIPMENT_ADD_BY_SERIAL_STARTED = 'EQUIPMENT_ADD_BY_SERIAL_STARTED';
export const EQUIPMENT_ADD_BY_SERIAL_FINISHED = 'EQUIPMENT_ADD_BY_SERIAL_FINISHED';
export const EQUIPMENT_ADD_BY_SERIAL_FAILED = 'EQUIPMENT_ADD_BY_SERIAL_FAILED';
export const RESET_CPE_EQUIPMENT_ADD = 'RESET_CPE_EQUIPMENT_ADD'

export const TECH_WORK_ORDER_TRANSFER_STARTED = 'TECH_WORK_ORDER_TRANSFER_STARTED';
export const TECH_WORK_ORDER_TRANSFER_FINISHED = 'TECH_WORK_ORDER_TRANSFER_FINISHED';
export const TECH_WORK_ORDER_TRANSFER_FAILED = 'TECH_WORK_ORDER_TRANSFER_FAILED';
export const CLEAR_WORK_ORDER_TRANSFER_STATE = 'CLEAR_WORK_ORDER_TRANSFER_STATE';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js